import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

function CollapsibleNav() {
	return (
		<Navbar collapseOnSelect expand='lg' bg='light' variant='light'>
			<Container>
				<Navbar.Toggle aria-controls='responsive-navbar-nav' />
				<Navbar.Collapse id='responsive-navbar-nav'>
					<Nav className='me-auto'>
						<NavDropdown title='Admissions' id='collasible-nav-dropdown'>
							<NavDropdown.Item href=''>Undergraduate Admission</NavDropdown.Item>
							<NavDropdown.Item href=''>Graduate Admission</NavDropdown.Item>
							<NavDropdown.Item href=''>International Students</NavDropdown.Item>
							<NavDropdown.Item href=''>Distance and Online</NavDropdown.Item>
							<NavDropdown.Item href=''>Cost and Aid</NavDropdown.Item>
						</NavDropdown>
						<NavDropdown title='Academics' id='collasible-nav-dropdown-1'>
							<NavDropdown.Item href=''>Areas of Study</NavDropdown.Item>
							<NavDropdown.Item href=''>Leading Programs</NavDropdown.Item>
							<NavDropdown.Item href=''>Career Preparation</NavDropdown.Item>
							<NavDropdown.Item href=''>Colleges</NavDropdown.Item>
						</NavDropdown>
						<Nav.Link href=''>Research</Nav.Link>
						<NavDropdown title='Student Life' id='collasible-nav-dropdown-2'>
							<NavDropdown.Item href=''>Iowa City</NavDropdown.Item>
							<NavDropdown.Item href=''>Living on Campus</NavDropdown.Item>
							<NavDropdown.Item href=''>Safety and Support</NavDropdown.Item>
						</NavDropdown>
						<NavDropdown title='About' id='collasible-nav-dropdown-3'>
							<NavDropdown.Item href=''>News</NavDropdown.Item>
							<NavDropdown.Item href=''>Events</NavDropdown.Item>
							<NavDropdown.Item href=''>Media Resources</NavDropdown.Item>
						</NavDropdown>
					</Nav>
					<Nav>
						<Nav.Link href=''>Athletics</Nav.Link>
						<Nav.Link href=''>Alumni and Giving</Nav.Link>
						<Nav.Link href=''>Health Care</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default CollapsibleNav;
